import { BaseManipStore } from '../new_base'
import contractitems from './subentities'
import * as linkConst from '../../../constants/link_constants'

export default class CItemManipStore extends BaseManipStore {
  loadEntry (id) {
    return this.store.requester.getEntry('contractitems', id)
      .then(loaded => {
        this.loadContract(loaded.contract_id)
        return loaded
      })
  }

  saveEntry (data) {
    data = data && typeof data !== 'object' ? Object.fromEntries(data) : data
    data.title = data.title.trim()
    return this.store.requester.saveEntry('contractitems', data, data.id)
  }

  onSaved (saved) {
    this.store.markDirty('contracts')
    this.store.markDirty('contractitems')
    super.onSaved(saved)
  }

  loadContract (contractId) {
    this.store.requester.getEntry('contracts', contractId)
      .then(contract => {
        this.contract = contract
      })
  }

  requiredOptions = [
    'ContractItemCategory',
    'ContractItemStatus',
    'ContractPricingTier',
    'Countries',
    'ExpenseTypes',
    'FlyprivateCategories',
    'Languages', // for YT table
    'Platforms',
    'PricingTiers',
    'RightsTypes',
    'UploadTypes',
    linkConst.LOAD_OPTIONS.clients,
    linkConst.LOAD_OPTIONS.contractitems,
    linkConst.LOAD_OPTIONS.contracts,
    linkConst.LOAD_OPTIONS.films,
    linkConst.LOAD_OPTIONS.flyprivate_pricings,
    linkConst.LOAD_OPTIONS.timeRestrictions
  ]

  onFieldChange (fieldName, value) {
    const id = Number(value)
    const film = this.store.options.get('films').find((i) => i.id === id)

    switch (fieldName) {
    case 'film_id':
      film && this.record.set('title', film.title ? film.title : film.slug)
      break
    }
  }

  validators = {
    title: (val) => this.lengthValidator(val),
    film_id: (val) => {
      return this.store.router.params.entname === 'contract' && this.lengthValidator(val)
    },
    contract_id: (val) => {
      return this.store.router.params.entname === 'film' && this.lengthValidator(val)
    },
    end_license_period: (val) => {
      const publishedAt = this.record.get('publish_date')
      const unpublishedAt = this.record.get('end_license_period')
      if (publishedAt && unpublishedAt && publishedAt > unpublishedAt) {
        return [this.store.__('published must be less than end license period')]
      }
    },
    shares: (val) => {
      if (Array.isArray(val) && val.length > 0) {
        const temp = []
        val.map(i => {
          const key = i.right_type + (i.source_of_revenues_cd || '')
          temp[key]
            ? temp[key] += parseFloat(i.share)
            : temp[key] = parseFloat(i.share)
        })
        var shareCondition = true
        for (const t in temp) {
          if (temp[t] !== 100 && temp[t] % 100 !== 0) {
            shareCondition = false
          }
        }
        return !shareCondition
          ? this.store.__('Total shares on every "Right type" (or with Limited to source of revenues) must be equal to 100%.')
          : undefined
      } else {
        return undefined
      }
    },
    _global: (state, items) => {
      // summary of shares must be 100 otherwise throw error!
      if (Array.isArray(items) && items.length > 0 && items[0].share && items[0].right_type) {
        const temp = []
        items.map(i => {
          const key = i.right_type + (i.source_of_revenues_cd || '')
          temp[key]
            ? temp[key] += parseFloat(i.share)
            : temp[key] = parseFloat(i.share)
        })
        var shareCondition = true
        for (const t in temp) {
          if (temp[t] !== 100 && temp[t] % 100 !== 0) {
            shareCondition = false
          }
        }
        this.errors.delete('shares')
        return !shareCondition
          ? this.store.__('Total shares on every "Right type" (or with Limited to source of revenues) must be equal to 100%.')
          : undefined
      } else {
        return undefined
      }
    }

  }

  back () {
    this.store.goTo('contractitems', {
      entname: this.store.router.params.entname,
      id: this.store.router.params.eid
    })
  }

  // add contract level (parent) shares to this contract item
  // that has corresponding right in this item
  handleSharesSync () {
    const parentShares = this.contract.shares
    const itemRights = this.record.get('rights')
    const recordShares = this.record.get('shares')
    const itemsToAdd = []

    parentShares.map(parShare => {
      // find enabling right to thins share
      const rightForThisShare = itemRights.find(i => {
        return i.right_type === parShare.right_type
      })
      // is already existing in this item?
      const existing = rightForThisShare && recordShares.find(rs => {
        return rs.contract_item_right_id === rightForThisShare.id
      })
      // if not exist and has enabling right, append
      if (rightForThisShare && !existing) {
        const newShare = Object.assign({}, parShare)
        newShare.contract_item_right_id = rightForThisShare.id
        newShare.control_timestamp = Math.round(new Date().getTime())
        delete newShare.id
        itemsToAdd.push(newShare)
      }
    })
    // Actually append new items to record
    if (itemsToAdd.length > 0) {
      const newVal = itemsToAdd.concat(this.record.get('shares').slice(0))
      this.record.get('shares').replace(newVal)
      this.store.addMessage(this.store.__('Shares synchronized'), 'success', 3000)
    } else {
      this.store.addMessage(this.store.__('There is nothing to be synchronized.'), 'warning', 4000)
    }
  }

  subentities = {
    rights: this.store.createEmbededEntityState(contractitems.rightsConf(this.store, () => {
      const cid = this.record.get('contract_id')
      const contractOpt = this.store.options.get('contracts').find((i) => i.id === cid)
      return contractOpt ? contractOpt.license_period_months : undefined
    })),
    limits: this.store.createEmbededEntityState(contractitems.limitsAttrs(this.store)),
    shares: this.store.createEmbededEntityState(contractitems.rightShares(this.store)),
    rightsCosts: this.store.createEmbededEntityState(contractitems.rightsCostsConfs(this.store)),
    // copy contract item rights
    rightsCopy: this.store.createEmbededEntityState(contractitems.rightsCopy(this.store))
  }

  initNew () {
    const url = this.store.router.params.entname === 'film' ? 'films' : 'contracts'
    this.store.requester.getEntry(url, this.store.router.params.eid)
      .then(data => {
        this.entity = data
        const rec = {
          title: '',
          minimal_guarantee: null,
          platform_publish_date_only: 0,
          status: 'new',
          limits: [],
          rights: [],
          shares: [],
          rightsCosts: []
        }
        if (this.store.router.params.entname === 'film') {
          rec.film_id = this.store.router.params.eid
          rec.title = this.entity && this.entity.title
        } else {
          rec.contract_id = this.store.router.params.eid
        }
        return rec
      }).then(data => {
        return this.onLoaded(data)
      })
  }
}
